import { render, staticRenderFns } from "./Payorder-report.vue?vue&type=template&id=ff826c04"
import script from "./Payorder-report.vue?vue&type=script&lang=js"
export * from "./Payorder-report.vue?vue&type=script&lang=js"
import style0 from "./Payorder-report.vue?vue&type=style&index=0&id=ff826c04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports